import { Component, OnInit, Input, OnChanges, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HandleError } from '../../../../components/common/utils/handleError.component';
import { PolizaEntity, Planes } from '../../entities/polizas_cliente_entity';
import { VamTitularEntity } from '../../../vam/titulares/entities/vam_titulares_entity';
import { SolicitudInclusionService } from './solicitud-inclusion.service';
import { InclusionEntity, PlanVam, IncluirBeneficiariosVam, ObjMultiSelectPolizas, ObjMultiSelectPlanes } from '../../entities/vam_entities';
import { MovimientosVamService } from '../movimientos/movimientosVam.service';
import { SessionStorageService, SessionStorage } from "ngx-webstorage";
import { ModalComponent } from "ng2-bs3-modal/ng2-bs3-modal";
import { ClienteLogin } from '../../../login/cliente_login';
import { SessionTokenService } from '../../../../components/common/utils/sessionToken.service';
import { UtilService } from '../../../../components/common/utils/util.service';
import { ListadosServices } from '../listados/listados.service';
import { elementAt } from 'rxjs/operator/elementAt';
import { forEach } from '@angular/router/src/utils/collection';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';
import { FileUploader } from 'ng2-file-upload';
import { ConstantService } from '../../../../components/common/utils/constant.service';

const swal = require("sweetalert2");


declare var jQuery: any;
@Component({
    selector: 'solicitudInclusion',
    templateUrl: 'solicitud-inclusion.template.html',
    styleUrls: ["solicitudes.style.css"]
})

export class SolicitudInclusionComponent implements OnChanges {
    @Input() polizaContratadaVam: PolizaEntity;
    @Input() planVam: number;
    @Input() planVamNombre: string;
    listaInclusion: InclusionEntity[];
    listaInclusionTit: InclusionEntity[];
    listaEdicionInclusionTit: InclusionEntity[];
    inclusionDepTit: IncluirBeneficiariosVam;
    showLoader: string;
    nombresPlanes: string[];
    planesVam: PlanVam[];
    planSeleccionado: number;
    nuevaInclusion: InclusionEntity;
    @ViewChild('modalInclusion')
    modal: ModalComponent;
    usuario: ClienteLogin;
    esTitular: boolean;

    banderaEditar: boolean;
    lista: boolean;
    listaVamTit: VamTitularEntity[];
    listaNombresTit: string[];
    listaNombresTitCod: string[];
    listaNombresTitNuevos: string[];
    listaNombresTitNuevosCod: string[];
    errorVal: boolean;
    public cboPolizas: ObjMultiSelectPolizas[];
    public PolizasSeleccionados: number[];
    numPolizasSeleccionadosAnterior: number;
    polizas: PolizaEntity[];
    polizasDatos: PolizaEntity;
    polizasEscogidas: PolizaEntity[];
    polizaContratadaVamSeleccionada: PolizaEntity;
    public cboPlanes: ObjMultiSelectPolizas[];
    public PlanesSeleccionados: number[];
    planesEscogidos: ObjMultiSelectPlanes[];
    numPlanesSeleccionadosAnterior: number;
    listaVamTitPlanes: VamTitularEntity[];
    VamTitPolEscogida: VamTitularEntity;
    public uploaderInc: FileUploader;
    private url = "vamEmpresas";
    es: any = {
        firstDayOfWeek: 1,
        dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
        dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
        dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
        monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", 'julio', "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
        monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"]
    };
    yearRange: string;
    maxDate: Date;
    minDate: Date;

    yearRange1: string;
    maxDate1: Date;
    minDate1: Date;

    mySettings: IMultiSelectSettings = {
        //    enableSearch: true,
        //   checkedStyle: 'fontawesome',
        buttonClasses: 'btn btn-default btn-block multiselect',
        dynamicTitleMaxItems: 3,
        displayAllSelectedText: true,
        containerClasses: 'multiselect'
    };
    myTexts: IMultiSelectTexts = {
        checkAll: 'Seleccionar todos',
        uncheckAll: 'Deseleccionar todos',
        checked: 'seleccionado',
        checkedPlural: 'seleccionados',
        searchPlaceholder: 'Buscar',
        defaultTitle: 'Selecccionar',
        allSelected: 'Todos seleccionados',
    };

    settingsCboClientes: IMultiSelectSettings = {
        enableSearch: true,
        dynamicTitleMaxItems: 0,
        buttonClasses: 'btn btn-default btn-block multiselect',
        displayAllSelectedText: true,
        containerClasses: 'multiselect'
    }
    settingsCboClientesRenovaciones: IMultiSelectSettings = {
        enableSearch: true,
        dynamicTitleMaxItems: 3,
        buttonClasses: 'btn btn-default btn-block multiselect',
        displayAllSelectedText: true,
        containerClasses: 'multiselect'
    }

    constructor(private route: ActivatedRoute,
        private router: Router, private handleError: HandleError,
        public solicitudInclusionService: SolicitudInclusionService,
        public utilsService: UtilService,
        public movimientosService: MovimientosVamService,
        public listadosServices: ListadosServices,
        private sessionTokenService: SessionTokenService,
        public sesionStorageService: SessionStorageService) {
        this.nuevaInclusion = new InclusionEntity();
        let now = new Date(Date.now());
        let past = new Date(Date.now());
        past.setFullYear(past.getFullYear() - 50);
        this.yearRange = (now.getFullYear() - 50) + ":" + now.getFullYear();
        this.maxDate = now;
        this.minDate = past;
        this.polizas = new Array<PolizaEntity>();
        this.polizasDatos = new PolizaEntity();
        this.polizasEscogidas = [];
        this.planesEscogidos = [];
        let past1 = new Date(Date.now());
        past.setFullYear(past.getFullYear() - 1);
        this.yearRange1 = (now.getFullYear() - 1) + ":" + now.getFullYear();
        this.maxDate1 = now;
        this.minDate1 = past;
        this.banderaEditar = false;
        this.errorVal = false;
        this.polizaContratadaVamSeleccionada = new PolizaEntity();
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;
        this.uploaderInc = new FileUploader({
            url: this.url + '/enviarSolInclusionAdjuntos',
            allowedMimeType: ['image/jpeg',
                'image/png',
                'application/pdf',
                'application/msword',
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
             //   'application/x-zip-compressed'
            ],
            maxFileSize: 15 * 1024 * 1024, /*limitado a 5 MB*/
            removeAfterUpload: true
        });
        this.uploaderInc.options.headers = [];

        this.uploaderInc.onAfterAddingFile = (file) => {
          //  this.uploadAllFiles(this.inclusionDepTit);

            file.withCredentials = false;
        };

    }

    ngOnChanges() {
        this.nombresPlanes = new Array<string>();
        this.planesVam = new Array<PlanVam>();

        this.planSeleccionado = 0;
        this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
        if (this.usuario == null) {
            let error = { "status": 998, "message": "Acceso denegado" };
            this.handleError.redirectUrl(error)
        } else {
            let bandera = this.sessionTokenService.useJwtHelper();
            if (!bandera) {
                let a = 1;

                this.nuevaInclusion = new InclusionEntity();
                this.listaInclusion = new Array<InclusionEntity>();
                this.listaInclusionTit = new Array<InclusionEntity>();
                this.listaEdicionInclusionTit = new Array<InclusionEntity>();
                this.inclusionDepTit = new IncluirBeneficiariosVam();
                this.inclusionDepTit.listaDependientes = new Array<InclusionEntity>();
                this.inclusionDepTit.listaTitulares = new Array<InclusionEntity>();
                this.nuevaInclusion.EsDependiente = false;
                this.lista = true;
                this.esTitular = false;
                this.listaNombresTitNuevos = new Array<string>();
                this.listaNombresTitNuevosCod = new Array<string>();
                this.listaVamTit = new Array<VamTitularEntity>();
                this.polizas = jQuery.parseJSON(this.sesionStorageService.retrieve("cmbpolizasData"));
            }
        }
    }

    GenerarTipo(tipoBen: number) {
        this.nuevaInclusion = new InclusionEntity();



        if (tipoBen == 1) {
            this.esTitular = true;
            this.nuevaInclusion.EsDependiente = false;
            this.cboPolizas = [];
            this.cboPolizas = jQuery.parseJSON(this.sesionStorageService.retrieve("cmbpolizas"));
            this.PolizasSeleccionados = [];
            this.numPolizasSeleccionadosAnterior = 0;
            this.polizasEscogidas = [];
        }
        if (tipoBen == 2) {
            this.esTitular = false;
            this.nuevaInclusion.EsDependiente = true;
            this.cboPolizas = [];

            this.cboPolizas = jQuery.parseJSON(this.sesionStorageService.retrieve("cmbpolizas"));

            this.PolizasSeleccionados = [];
            this.numPolizasSeleccionadosAnterior = 0;
            this.polizasEscogidas = [];
            if (this.listaNombresTit == undefined) {
                this.listaVamTit = new Array<VamTitularEntity>();
                this.listaNombresTit = new Array<string>();
                this.listaNombresTitCod = new Array<string>();
                this.cargarListadosXpolizas();
            }
            else {
                this.AñadirTitularNuevosPorPolizaPlan();
            }
        }


    }



    ChangeText(cedula: string) {
        this.inclusionDepTit.listaTitulares.filter((function (el) {
            if (el.Identificacion == cedula && this.banderaEditar == false) {
                this.errorVal = true;
                swal({
                    title: 'Beneficiario existente',
                    text: 'Este titular ya ha sido ingresado como beneficiario',
                    type: 'error'
                });
            }
            else {
                this.errorVal = false;
            }

        }).bind(this));

        this.inclusionDepTit.listaDependientes.filter((function (el) {
            if (el.Identificacion == cedula && this.banderaEditar == false) {
                this.errorVal = true;
                swal({
                    title: 'Beneficiario existente',
                    text: 'Este dependiente ya ha sido ingresado como beneficiario',
                    type: 'error'
                });

            }
            else {
                this.errorVal = false;
            }

        }).bind(this));

    }

    onSelectMethod(event) {
        if (!this.nuevaInclusion.EsDependiente) {
            let anioActual = new Date(Date.now());
            let fechaNac = new Date(Date.parse(event));
            let edad = anioActual.getFullYear() - fechaNac.getFullYear();
            if (edad < 18) {
                this.errorVal = true;
                swal({
                    title: 'Titular erroneo',
                    text: 'El titular debe ser mayor de edad',
                    type: 'error'
                });
            }
            else
                this.errorVal = false;
        }
        else
            this.errorVal = false;
    }

    IncluirNuevoBeneficiario() {
        if (this.esTitular)
            this.IncluirNuevoTitular();
        else
            this.IncluirNuevoDependiente();
    }

    IncluirNuevoTitular() {
        let nuevaInclusionTitularDependiente = new InclusionEntity();
        nuevaInclusionTitularDependiente.Identificacion = this.nuevaInclusion.Identificacion;
        this.inclusionDepTit.listaTitulares = this.inclusionDepTit.listaTitulares.filter(function (el) { return el.Identificacion != nuevaInclusionTitularDependiente.Identificacion; });


        for (let c of this.polizasEscogidas) {

            let valor = this.inclusionDepTit.listaTitulares.find(el => el.Identificacion == this.nuevaInclusion.Identificacion && el.CodigoPlan == c.CodigoPlan && el.Poliza == c.CodigoPoliza);
            if (valor == undefined) {



                let plan = new PlanVam();
                plan = c.Planes.find(a => a.CodigoPlanCliente == c.CodigoPlanCliente)
                let nuevaInclusionTitularDependiente = new InclusionEntity();
                nuevaInclusionTitularDependiente.Identificacion = this.nuevaInclusion.Identificacion;
                nuevaInclusionTitularDependiente.NombresPersonaIncluir = this.nuevaInclusion.NombresPersonaIncluir.toUpperCase();
                nuevaInclusionTitularDependiente.ApellidosPersonaIncluir = this.nuevaInclusion.ApellidosPersonaIncluir.toUpperCase();
                nuevaInclusionTitularDependiente.Email = this.nuevaInclusion.Email;
                nuevaInclusionTitularDependiente.CodigoSexo = this.nuevaInclusion.CodigoSexo;
                nuevaInclusionTitularDependiente.CodigoRel = this.nuevaInclusion.CodigoRel;
                nuevaInclusionTitularDependiente.FechaInclusion = this.nuevaInclusion.FechaInclusion;
                nuevaInclusionTitularDependiente.FechaNacimiento = this.nuevaInclusion.FechaNacimiento;

                nuevaInclusionTitularDependiente.CodigoCiudad = c.CodigoCiudad;
                nuevaInclusionTitularDependiente.CodigoCliente = c.CodigoCliente;
                nuevaInclusionTitularDependiente.NombrePlan = plan.Nombre;
                nuevaInclusionTitularDependiente.Poliza = c.CodigoPoliza;
                nuevaInclusionTitularDependiente.CodigoPlan = c.CodigoPlanCliente;
                nuevaInclusionTitularDependiente.CodigoUsuario = this.usuario.CodigoUsuario;
                nuevaInclusionTitularDependiente.CodigoPolCmb = c.CodigoPolCmb;

                this.banderaEditar = false;
                let codigo = this.nuevaInclusion;



                this.nuevaInclusion.Relacion = "Titular";


                if (nuevaInclusionTitularDependiente.CodigoSexo == 1)
                    nuevaInclusionTitularDependiente.Genero = "Femenino";
                else
                    nuevaInclusionTitularDependiente.Genero = "Masculino";

                this.inclusionDepTit.listaTitulares.push(nuevaInclusionTitularDependiente);
                let cod = this.listaNombresTitNuevosCod.find(s => s.includes(nuevaInclusionTitularDependiente.NombresPersonaIncluir + " " + nuevaInclusionTitularDependiente.ApellidosPersonaIncluir));
                if (cod == undefined) {
                    this.listaNombresTitNuevos.push(nuevaInclusionTitularDependiente.NombresPersonaIncluir.toUpperCase() + " " + nuevaInclusionTitularDependiente.ApellidosPersonaIncluir.toUpperCase());
                    this.listaNombresTitNuevosCod.push(nuevaInclusionTitularDependiente.NombresPersonaIncluir.toUpperCase() + " " + nuevaInclusionTitularDependiente.ApellidosPersonaIncluir.toUpperCase() + "," + nuevaInclusionTitularDependiente.Identificacion);
                }

            }
            this.modal.close();


            if (this.inclusionDepTit.listaDependientes.length > 0 || this.inclusionDepTit.listaTitulares.length > 0) {
                this.lista = false;

            }
            else
                this.lista = true;
        }

        this.nuevaInclusion = new InclusionEntity();
    }

    IncluirNuevoDependiente() {

        let nuevaInclusionTitularDependiente = new InclusionEntity();
        nuevaInclusionTitularDependiente.Identificacion = this.nuevaInclusion.Identificacion;
        this.inclusionDepTit.listaDependientes = this.inclusionDepTit.listaDependientes.filter(function (el) { return el.Identificacion != nuevaInclusionTitularDependiente.Identificacion; });

        for (let c of this.polizasEscogidas) {
            let plan = new PlanVam();
            plan = c.Planes.find(a => a.CodigoPlanCliente == c.CodigoPlanCliente)
            let nuevaInclusionTitularDependiente = new InclusionEntity();
            nuevaInclusionTitularDependiente.NombresApellidosTitular = this.nuevaInclusion.NombresApellidosTitular;
            nuevaInclusionTitularDependiente.Identificacion = this.nuevaInclusion.Identificacion;
            nuevaInclusionTitularDependiente.NombresPersonaIncluir = this.nuevaInclusion.NombresPersonaIncluir.toUpperCase();
            nuevaInclusionTitularDependiente.ApellidosPersonaIncluir = this.nuevaInclusion.ApellidosPersonaIncluir.toUpperCase();
            nuevaInclusionTitularDependiente.Email = this.nuevaInclusion.Email;
            nuevaInclusionTitularDependiente.CodigoSexo = this.nuevaInclusion.CodigoSexo;
            nuevaInclusionTitularDependiente.CodigoRel = this.nuevaInclusion.CodigoRel;
            nuevaInclusionTitularDependiente.FechaInclusion = this.nuevaInclusion.FechaInclusion;
            nuevaInclusionTitularDependiente.FechaNacimiento = this.nuevaInclusion.FechaNacimiento;

            nuevaInclusionTitularDependiente.CodigoCiudad = c.CodigoCiudad;
            nuevaInclusionTitularDependiente.CodigoCliente = c.CodigoCliente;
            nuevaInclusionTitularDependiente.NombrePlan = plan.Nombre;
            nuevaInclusionTitularDependiente.Poliza = c.CodigoPoliza;
            nuevaInclusionTitularDependiente.CodigoPlan = c.CodigoPlanCliente;
            nuevaInclusionTitularDependiente.CodigoUsuario = this.usuario.CodigoUsuario;
            nuevaInclusionTitularDependiente.CodigoPolCmb = c.CodigoPolCmb;
            nuevaInclusionTitularDependiente.EsDependiente = this.nuevaInclusion.EsDependiente;
            nuevaInclusionTitularDependiente.CodigoTitular = this.nuevaInclusion.CodigoTitular;
            nuevaInclusionTitularDependiente.CedulaTitular = this.nuevaInclusion.CedulaTitular;

            this.banderaEditar = false;
            let codigo = this.nuevaInclusion;


            if (nuevaInclusionTitularDependiente.EsDependiente) {

                if (nuevaInclusionTitularDependiente.CodigoRel == 2) {
                    nuevaInclusionTitularDependiente.Relacion = "Hijo(a)";
                }
                if (nuevaInclusionTitularDependiente.CodigoRel == 3) {
                    nuevaInclusionTitularDependiente.Relacion = "Conyugue";
                }
                if (nuevaInclusionTitularDependiente == 4) {
                    nuevaInclusionTitularDependiente.Relacion = "Progenitor(a)";
                }

            }
            else {
                nuevaInclusionTitularDependiente.Relacion = "Titular";
            }

            if (nuevaInclusionTitularDependiente.CodigoSexo == 1)
                nuevaInclusionTitularDependiente.Genero = "Femenino";
            else
                nuevaInclusionTitularDependiente.Genero = "Masculino";

            this.inclusionDepTit.listaDependientes.push(nuevaInclusionTitularDependiente);

        }

        this.modal.close();
        this.nuevaInclusion = new InclusionEntity();

        if (this.inclusionDepTit.listaDependientes.length > 0 || this.inclusionDepTit.listaTitulares.length > 0) {
            this.lista = false;

        }
        else
            this.lista = true;

    }


    editarInclusionNueva(nuevo) {
        let cont = 0;
        this.cboPolizas = [];
        this.cboPolizas = jQuery.parseJSON(this.sesionStorageService.retrieve("cmbpolizas"));
        this.PolizasSeleccionados = [];
        this.numPolizasSeleccionadosAnterior = 0;
        this.polizasEscogidas = [];
        for (let c of this.inclusionDepTit.listaDependientes) {
            if (c.Identificacion == nuevo.Identificacion) {
                this.listaEdicionInclusionTit.push(c);
                this.PolizasSeleccionados.push(c.CodigoPolCmb);
                this.polizasDatos = this.polizas.find(a => a.CodigoPoliza == c.Poliza);
                this.polizasDatos.CodigoPlan = c.CodigoPlan;
                this.polizasEscogidas.push(this.polizasDatos);

                cont++;
            }
        }
        this.numPolizasSeleccionadosAnterior = cont;
        this.nuevaInclusion = this.cloneExtra(nuevo);
        this.banderaEditar = true;
        this.modal.open();
        this.esTitular = false;
    }

    editarInclusionNuevaTit(nuevoTit) {
        let cont = 0;
        this.cboPolizas = [];
        this.cboPolizas = jQuery.parseJSON(this.sesionStorageService.retrieve("cmbpolizas"));
        this.PolizasSeleccionados = [];
        this.numPolizasSeleccionadosAnterior = 0;
        this.polizasEscogidas = [];
        for (let c of this.inclusionDepTit.listaTitulares) {
            if (c.Identificacion == nuevoTit.Identificacion) {
                this.listaEdicionInclusionTit.push(c);
                this.PolizasSeleccionados.push(c.CodigoPolCmb);
                this.polizasDatos = this.polizas.find(a => a.CodigoPoliza == c.Poliza);
                this.polizasDatos.CodigoPlan = c.CodigoPlan;
                this.polizasEscogidas.push(this.polizasDatos);

                cont++;
            }
        }
        this.numPolizasSeleccionadosAnterior = cont;
        this.nuevaInclusion = this.cloneExtra(nuevoTit);
        this.banderaEditar = true;
        this.modal.open();
        this.esTitular = true;
    }

    eliminarInclusionNueva(nuevo) {
        let pos = this.inclusionDepTit.listaDependientes.findIndex(z => z.Identificacion == nuevo.Identificacion && z.CodigoPlan == nuevo.CodigoPlan);
        this.inclusionDepTit.listaDependientes.splice(pos, 1);

        if (this.inclusionDepTit.listaDependientes.length > 0 || this.inclusionDepTit.listaTitulares.length > 0)
            this.lista = false;
        else
            this.lista = true;

    }


    eliminarInclusionNuevaTit(nuevoTit) {
        this.eliminarInclusionDependiente(nuevoTit.Identificacion, "", nuevoTit.CodigoPlan);
        let pos = this.inclusionDepTit.listaTitulares.findIndex(z => z.Identificacion == nuevoTit.Identificacion && z.CodigoPlan == nuevoTit.CodigoPlan);
        this.inclusionDepTit.listaTitulares.splice(pos, 1);

        if (this.inclusionDepTit.listaDependientes.length > 0 || this.inclusionDepTit.listaTitulares.length > 0) {
            this.lista = false;
        }
        else
            this.lista = true;

    }
    eliminarInclusionDependiente(cedula: string, poliza: string, plan: number) {

        let pos = this.inclusionDepTit.listaDependientes.findIndex(z => z.CedulaTitular == cedula && z.CodigoPlan == plan);
        if (pos != -1) {
            this.inclusionDepTit.listaDependientes.splice(pos, 1);
        }
        if (this.inclusionDepTit.listaDependientes.length > 0 || this.inclusionDepTit.listaTitulares.length > 0) {
            this.lista = false;
        }
        else
            this.lista = true;

    }

    cloneExtra(c: InclusionEntity) {
        let inclusion = new InclusionEntity();
        for (let prop in c) {
            inclusion[prop] = c[prop];
        }
        return inclusion;
    }

    modalClose() {
        this.modal.close();
        this.nuevaInclusion = new InclusionEntity();
        this.banderaEditar = false;
        this.errorVal = false;
    }

    set dateS(e) {
        this.nuevaInclusion.FechaNacimiento = new Date(e);
    }

    get dateS() {
        if (this.nuevaInclusion.FechaNacimiento != undefined) {
            try {
                var a = this.nuevaInclusion.FechaNacimiento.toISOString().substring(0, 10);
                var b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            } catch (e) {
                var a = this.nuevaInclusion.FechaNacimiento.toString().substring(0, 10);
                var b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            }
        }
    }
    set dateInc(e) {
        this.nuevaInclusion.FechaInclusion = new Date(e);
    }

    get dateInc() {
        if (this.nuevaInclusion.FechaInclusion != undefined) {
            try {
                var a = this.nuevaInclusion.FechaInclusion.toISOString().substring(0, 10);
                var b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            } catch (e) {
                var a = this.nuevaInclusion.FechaInclusion.toString().substring(0, 10);
                var b = a.split("-");
                return b[2] + "/" + b[1] + "/" + b[0];
            }
        }
    }


    EnviarSolicitudInclusion() {
        this.showLoader = "sk-loading";

        if (this.uploaderInc.getNotUploadedItems().length == 1) {

            let objetoPreautorizacion = JSON.stringify(this.inclusionDepTit);
            this.uploaderInc.options.headers.push(
                { name: 'IncluirBeneficiariosVam', value: objetoPreautorizacion }
            );

            this.uploaderInc.uploadItem(this.uploaderInc.getNotUploadedItems()[0]);
        } else if (this.uploaderInc.queue.length > 1) {
            this.uploadAllFiles(this.inclusionDepTit);
            this.uploaderInc.clearQueue();
        } else {
            this.solicitudInclusionService.EnviarSolicitudInclusion(this.inclusionDepTit).subscribe(
                result => {
    
                    swal({
                        title: 'Solicitud enviada exitosamente',
                        text: 'La solicitud de inclusión se realizó correctamente',
                        type: 'success'
                    });
                    this.showLoader = "";
                    this.ngOnChanges();
                },
                error => {
                    this.showLoader = "";
                    this.handleError.redirectUrl(error);
                }
            );
        }

        
    }

    onChangePoliza(e) {


        if (this.numPolizasSeleccionadosAnterior > e.length) {
            for (let c of this.polizasEscogidas) {
                let existe = false;
                for (let b of this.PolizasSeleccionados) {
                    if (c.CodigoPoliza == b.toString()) {
                        existe = true;
                    }
                }
                if (!existe) {
                    var index = this.polizasEscogidas.indexOf(c);
                    this.polizasEscogidas.splice(index, 1);
                }
            }
            this.numPolizasSeleccionadosAnterior = e.length;
        }
        else {

            let e1 = e[e.length - 1]//código de la poliza

            //añado la poliza
            let polc = this.cboPolizas.find(a => a.id == e1);

            //busco datos de la poliza
            let polcod = this.cboPolizas.find(a => a.id == e1).name;
            this.polizasDatos = this.polizas.find(a => a.CodigoPoliza == polcod);
            this.polizasDatos.CodigoPolCmb = e1;
            this.polizasEscogidas.push(this.polizasDatos);
            this.polizasDatos.CodigoPlan = 0;
            if (this.esTitular != true) {
                this.consultarplanesTitularEscogido(this.polizasDatos);
            }
            else {
                this.consultarplanespoliza(this.polizasDatos);
            }

            this.numPolizasSeleccionadosAnterior = this.polizasEscogidas.length;
        }
    }
    consultarplanespoliza(polizaEscogida: PolizaEntity) {
        this.movimientosService.consultaPlanes(polizaEscogida).subscribe(
            result => {
                polizaEscogida.Planes = result.sort((a, b) => a.Nombre.localeCompare(b.Nombre));
                this.nombresPlanes = result.map(a => a.Nombre).sort();

            },
            error => {
                this.handleError.redirectUrl(error);
            }
        );
    }
    TraerListadoTitularPorPolizaPlan(polizaEscogida: PolizaEntity[]) {
        this.errorVal = false;
        this.ChangeText(this.nuevaInclusion.Identificacion);
        this.showLoader = "sk-loading";
        this.listadosServices.ConsultarListadosPorPolizas(polizaEscogida).subscribe(
            result => {
                this.listaVamTit = result;
                this.listaVamTit.forEach(item => {

                    let existe = this.listaNombresTit.find(s => s.includes(item.ApellidoPaterno + " " + item.ApellidoMaterno + " " + item.PrimerNombre + " " + item.SegundoNombre));
                    if (existe == undefined) {
                        this.listaNombresTit.push(item.ApellidoPaterno + " " + item.ApellidoMaterno + " " + item.PrimerNombre + " " + item.SegundoNombre);

                    }
                    this.listaNombresTitCod.push(item.ApellidoPaterno + " " + item.ApellidoMaterno + " " + item.PrimerNombre + " " + item.SegundoNombre + "," + item.CodigoTitular.toString());

                });
                if (this.listaNombresTitNuevos.length != 0) {
                    this.listaNombresTitNuevos.forEach(item => {
                        this.listaNombresTit.push(item);
                    });
                }
                if (this.listaNombresTitNuevosCod.length != 0) {
                    this.listaNombresTitNuevosCod.forEach(item => {
                        this.listaNombresTitCod.push(item);
                    });
                }
                this.showLoader = "";
            },
            error => {
                this.handleError.redirectUrl(error);
            }
        );

    }
    AñadirTitularNuevosPorPolizaPlan() {

        if (this.listaNombresTitNuevos.length != 0) {

            this.listaNombresTitNuevos.forEach(item => {
                let existe = this.listaNombresTit.find(s => s.includes(item));
                if (existe == undefined) {
                    this.listaNombresTit.push(item);
                }
            });
        }
        if (this.listaNombresTitNuevosCod.length != 0) {
            this.listaNombresTitNuevosCod.forEach(item => {

                let existe = this.listaNombresTitNuevosCod.find(s => s.includes(item));
                if (existe == undefined) {
                    this.listaNombresTitCod.push(item);
                }
            });
        }


    }
    buscarTitulares(codigoTitular) {
        this.cboPolizas = [];
        let cboPolizasCliente = jQuery.parseJSON(this.sesionStorageService.retrieve("cmbpolizas"));
        this.listaVamTitPlanes = [];
        if (codigoTitular != null) {
            let cod = this.listaNombresTitCod.find(s => s.includes(codigoTitular.originalObject));
            if (cod.substring(cod.indexOf(",")).replace(",", "").length >= 10) {
                this.nuevaInclusion.CedulaTitular = (cod.substring(cod.indexOf(",")).replace(",", ""));
                for (let c of this.inclusionDepTit.listaTitulares) {
                    if (c.Identificacion == this.nuevaInclusion.CedulaTitular) {
                        let poliza = this.inclusionDepTit.listaTitulares.find(s => s.Identificacion == this.nuevaInclusion.CedulaTitular && s.CodigoPolCmb == c.CodigoPolCmb).Poliza.trim()
                        this.cboPolizas.push(cboPolizasCliente.find(s => s.name == poliza.trim()));

                    }
                }
            }
            else {


                this.nuevaInclusion.CodigoTitular = Number(cod.substring(cod.indexOf(",")).replace(",", ""));
                let poltitular = this.listaVamTit.find(a => a.CodigoTitular == this.nuevaInclusion.CodigoTitular);
                this.listaVamTitPlanes.push(poltitular);
                this.listadosServices.consultaPlanesxTitular(this.listaVamTitPlanes).subscribe(
                    result => {

                        for (let c of result) {
                            this.VamTitPolEscogida = c;
                            for (let d of c.Poliza) {
                                if (cboPolizasCliente.find(s => s.name == d.CodigoPoliza.trim()) != undefined) {
                                    this.cboPolizas.push(cboPolizasCliente.find(s => s.name == d.CodigoPoliza.trim()));
                                }
                            }

                        }
                    },
                    error => {
                        this.handleError.redirectUrl(error);
                    }
                );
            }
        }
    }
    cargarListadosXpolizas() {
        let polizas = new Array<PolizaEntity>();
        for (let c of this.cboPolizas) {
            let pol = this.polizas.find(a => a.CodigoPoliza.includes(c.name))
            if (pol != undefined) {
                polizas.push(pol);
            }
        }
        this.TraerListadoTitularPorPolizaPlan(polizas);
    }
    consultarplanesTitularEscogido(polizaEscogida: PolizaEntity) {

        if (this.nuevaInclusion.CodigoTitular != undefined) {
            let poltitular = this.listaVamTit.find(a => a.CodigoTitular == this.nuevaInclusion.CodigoTitular);
            let plantit = this.VamTitPolEscogida.Poliza.find(s => s.CodigoPoliza.trim() == polizaEscogida.CodigoPoliza.trim()).CodigoPlan;
            this.movimientosService.consultaPlanes(polizaEscogida).subscribe(
                result => {
                    let pol = result.sort((a, b) => a.Nombre.localeCompare(b.Nombre));
                    polizaEscogida.Planes = pol.filter(a => a.CodigoPlanCliente == plantit)
                    this.nombresPlanes = result.map(a => a.Nombre).sort();

                },
                error => {
                    this.handleError.redirectUrl(error);
                }
            );
        }
        else {
            let plantit = this.inclusionDepTit.listaTitulares.find(s => s.Identificacion == this.nuevaInclusion.CedulaTitular && s.Poliza.trim() == polizaEscogida.CodigoPoliza.trim()).CodigoPlan;
            this.movimientosService.consultaPlanes(polizaEscogida).subscribe(
                result => {
                    let pol = result.sort((a, b) => a.Nombre.localeCompare(b.Nombre));
                    polizaEscogida.Planes = pol.filter(a => a.CodigoPlanCliente == plantit)
                    this.nombresPlanes = result.map(a => a.Nombre).sort();

                },
                error => {
                    this.handleError.redirectUrl(error);
                }
            );
        }
    }
    uploadAllFiles(inclusionDepTit: IncluirBeneficiariosVam): void {
        this.showLoader = "sk-loading";
     // let  archivosAdjuntosSubida: ArchivosAdjuntosEntity[];
     // let  archivosAdjuntosSubidaVacio: ArchivosAdjuntosEntity[];
      //console.log(this.archivosAdjuntos)
        const xhr = new XMLHttpRequest();
        const form = new FormData();

        for (const fileItem of this.uploaderInc.getNotUploadedItems()) {
            form.append(fileItem.file.name, fileItem._file, fileItem.file.name);
        }

        xhr.onreadystatechange = (function () {
            if (xhr.readyState === 4) {
                this.showLoadermodal = "";
                var archivos = jQuery.parseJSON(xhr.response);

               
                
                
            }
        }).bind(this);
        xhr.open("post", this.url + '/enviarSolInclusionAdjuntos', true);
        xhr.setRequestHeader("enctype", "multipart/form-data");
        // IE workaround for Cache issues
        xhr.setRequestHeader("Cache-Control", "no-cache");
        xhr.setRequestHeader("Cache-Control", "no-store");
        xhr.setRequestHeader("Pragma", "no-cache");
        xhr.setRequestHeader("Authorization", "Token " + sessionStorage.getItem("Token"));
        //let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let objetoPreautorizacion = JSON.stringify(inclusionDepTit);

        xhr.setRequestHeader("inclusionDepTit", objetoPreautorizacion);
        xhr.send(form);
        //console.log(this.url + '/GenerarCarta')
        this.showLoader = "";
    }

}



// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/vamEmpresa/solicitudes/solicitud-inclusion.component.ts